import Vue from '@vue/compat';
import CircleManageModal from './components/CircleManageModal.vue';
import CirclePostManage from './components/CirclePostManage.vue';
import CircleUserManage from './components/CircleUserManage.vue';
import CreateTopicModal from './components/CreateTopicModal.vue';
import JoinCircleModal from './components/JoinCircleModal.vue';
import './lib/page-script';

Vue.component('circleManage', CircleManageModal);
Vue.component('qk-circle-user-manage', CircleUserManage);
Vue.component('qk-circle-post-manage', CirclePostManage);
Vue.component('createTopic', CreateTopicModal);
Vue.component('joinCircle', JoinCircleModal);
import './pages/circle/mount.js';
